export default "__VITE_ASSET__CCM0RjM2__"